import { memo, useEffect, useState } from 'react';
import { PhoneIcon } from './icons';
import { scrollToHash } from '../utils/nav';

/**
 * Fixed site header. Transparent over the gradient hero, then frosts to a light
 * bar once the hero has scrolled past. Nav anchors only render for sections that
 * exist on the page; "Get in Touch" opens the pop-up form, "Call Now" dials.
 */
export const Header = memo(({ logoUrl, wordmark, navItems = [], phone, onGetInTouch }) => {
  const [scrolled, setScrolled] = useState(false);
  const [logoOk, setLogoOk] = useState(true);

  useEffect(() => {
    const hero = document.getElementById('hero');
    const update = () => {
      const threshold = hero ? hero.offsetHeight - 70 : 320;
      setScrolled(window.scrollY > threshold);
    };
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
    return () => {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, []);

  return (
    <header className={`site-header${scrolled ? ' scrolled' : ''}`} id="site-header">
      <div className="cw-container header-inner">
        <a className="header-brand" href="#top" onClick={e => scrollToHash('#top', e)}>
          {logoUrl && logoOk && (
            <img
              className="header-logo"
              src={logoUrl}
              alt={wordmark ? `${wordmark} logo` : 'Logo'}
              onError={() => setLogoOk(false)}
            />
          )}
          <span className="header-wordmark">{wordmark}</span>
        </a>
        <nav className="header-nav" aria-label="Page sections">
          {navItems.map(({ href, label }) => (
            <a key={href} href={href} onClick={e => scrollToHash(href, e)}>
              {label}
            </a>
          ))}
        </nav>
        <div className="header-actions">
          {phone && (
            <a className="btn btn-ghost btn-header" href={`tel:${phone.anchor}`}>
              <PhoneIcon size={13} />
              Call Now
            </a>
          )}
          <button type="button" className="btn btn-primary btn-header" onClick={onGetInTouch}>
            Get in Touch
          </button>
        </div>
      </div>
    </header>
  );
});
